import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'bb-chip-group\' ...attributes>\n  {{#each @options as |opt|}}\n    <button\n      type=\'button\'\n      class=\'bb-chip {{if (is-equal @selected opt.value) \"is-active\"}}\'\n      title={{opt.hint}}\n      data-test-select\n      {{on \'click\' (fn this.select opt.value)}}\n    >\n      {{opt.label}}\n    </button>\n  {{/each}}\n  {{yield}}\n</div>");

var _class;
let BbChipGroup = (_class = class BbChipGroup extends Component {
  select(value) {
    this.args.onChange?.(value);
  }
}, _applyDecoratedDescriptor(_class.prototype, "select", [action], Object.getOwnPropertyDescriptor(_class.prototype, "select"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbChipGroup);

export { BbChipGroup as default };
//# sourceMappingURL=bb-chip-group.js.map
